import React, { useEffect } from "react";
import { useDispatch, useSelector } from "@pages/Events/MiniGame/store";
import bgLucky from "../../../../assets/images/Mini-Game/bg-lucky.png";
import imgGift from "../../../../assets/images/Mini-Game/img-gift.png";
import styled from "styled-components";
import prizeTray from "../../../../assets/images/Mini-Game/prize-tray.png";
import prizeTrayFw from "../../../../assets/images/Mini-Game/prize-tray-forward.png";
import prizeTrayNewYear from "../../../../assets/images/Mini-Game/new-year-2025/prize-tray.png";
import prizeTrayFwNewYear from "../../../../assets/images/Mini-Game/new-year-2025/prize-tray-forward.png";
import { Button } from "antd";
import { useNavigate } from "@hooks/useNavigate";
import PATH from "../../../../config/PATH";
import {
  ID_TAB_MINI_GAME,
  useNewYear2025Theme,
  useThadingyutTheme,
  // IS_EVENT_THADINGYUT_2025_THEME,
} from "../../../../helper/const";
import iconGift from "../../../../assets/images/Mini-Game/icon-gift.svg";
import iconPiece from "../../../../assets/images/Mini-Game/icon-piece.svg";
import bgTakePrize from "../../../../assets/images/Mini-Game/bg-take-prize-btn.png";
import bgPieceCollection from "../../../../assets/images/Mini-Game/bg-piece-collection-btn.png";
import bgTakePrizeNewYear from "../../../../assets/images/Mini-Game/new-year-2025/bg-take-prize-btn.png";
import bgPieceCollectionNewYear from "../../../../assets/images/Mini-Game/new-year-2025/bg-piece-collection-btn.png";
import _ from "lodash";
import { curStateMiniGame } from "../../../../Redux/selector";
import { useTranslation } from "react-i18next";
import iconGift3d from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/prize-icon.png";
import iconPiece3d from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/piece-icon.png";
import iconGiftNewYear from "../../../../assets/images/Mini-Game/new-year-2025/icon-prize.png";
import iconPieceNewYear from "../../../../assets/images/Mini-Game/new-year-2025/icon-piece.png";
import iconPieceSuper from "../../../../assets/images/Mini-Game/new-year-2025/icon-piece-super.png";

export default function ListPrizes({ dataAwardList }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dataMiniGame = useSelector(curStateMiniGame);
  const IS_EVENT_THADINGYUT_2025_THEME = useThadingyutTheme();
  const IS_EVENT_NEW_YEAR_2025_THEME = useNewYear2025Theme();

  // useEffect(() => {
  //   if (_.isEmpty(dataMiniGame.dataAwardListMini)) {
  //     dispatch(getDataAwardListMiniGame());
  //   }
  // }, []);

  const handleTopage = (id) => {
    navigate(`${PATH.MINI_GAME}/${id}/${dataAwardList[0]?.id}`);
  };

  const handleToItem = (id) => {
    navigate(`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.pieceCollection}/${id}`);
  };

  return (
    <Container>
      <div
        className={`body-luck-minigame ${
          IS_EVENT_NEW_YEAR_2025_THEME ? "new-year-25-theme" : ""
        }`}
      >
        <div className='container-body-luck container-buy-more'>
          {dataAwardList.map((item, index) => (
            <Div
              key={item.id}
              className={`${
                IS_EVENT_NEW_YEAR_2025_THEME ? "new-year-25-theme" : ""
              } item`}
              onClick={() => handleToItem(item.id)}
            >
              {item.is_super_prize === "1" && IS_EVENT_NEW_YEAR_2025_THEME && (
                <img src={iconPieceSuper} alt='' className='icon-super-piece' />
              )}
              <img
                src={
                  IS_EVENT_NEW_YEAR_2025_THEME ? prizeTrayNewYear : prizeTray
                }
                alt=''
                className='img-prize-tray'
                draggable={false}
              />
              <img
                src={item.image}
                alt=''
                draggable={false}
                className='prize'
              />
              <div className='forward'>
                <div className='forward-inner'>
                  <img
                    src={
                      IS_EVENT_NEW_YEAR_2025_THEME
                        ? prizeTrayFwNewYear
                        : prizeTrayFw
                    }
                    alt=''
                    className='img-prize-tray-fw'
                  />
                  <p className='prize-name'>{item.name}</p>
                </div>
              </div>
            </Div>
          ))}
        </div>
      </div>

      <div
        className={`btn-group ${
          IS_EVENT_NEW_YEAR_2025_THEME ? "new-year-25-theme" : ""
        }`}
      >
        <Button
          className='btn-item btn-item-take-prize scale-hover-item'
          onClick={() => handleTopage(ID_TAB_MINI_GAME.takePrize)}
        >
          {IS_EVENT_THADINGYUT_2025_THEME ? (
            <img srcSet={`${iconGift3d} 2x`} alt='' />
          ) : IS_EVENT_NEW_YEAR_2025_THEME ? (
            <img srcSet={`${iconGiftNewYear} 2x`} alt='' />
          ) : (
            <img src={iconGift} alt='' />
          )}
          <span>{t("mini_game.homepage.take_prize")}</span>
        </Button>

        <Button
          className='btn-item btn-item-piece-collection scale-hover-item'
          onClick={() => handleTopage(ID_TAB_MINI_GAME.pieceCollection)}
        >
          {IS_EVENT_THADINGYUT_2025_THEME ? (
            <img srcSet={`${iconPiece3d} 2x`} alt='' />
          ) : IS_EVENT_NEW_YEAR_2025_THEME ? (
            <img srcSet={`${iconPieceNewYear} 2x`} alt='' />
          ) : (
            <img src={iconPiece} alt='' />
          )}
          <span>{t("mini_game.homepage.piece_collection")}</span>
        </Button>
      </div>
    </Container>
  );
}

const Container = styled.div`
  .btn-group {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    margin-top: 12px;

    &.new-year-25-theme {
      .btn-item-take-prize {
        background-image: url(${bgTakePrizeNewYear});
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position-x: center;
        background-position-y: center;
        box-shadow: -10px 10px 20px 0px #351212cc;
        gap: 0px;
        &:hover,
        &:active {
          background-image: url(${bgTakePrizeNewYear});
        }
        span {
          text-shadow: -1px -1px 0 #00386f, 1px -1px 0 #00386f,
            -1px 1px 0 #00386f, 1px 1px 0 #00386f;
        }

        @media (max-width: 768px) {
          img {
            width: 36px;
          }
        }
      }
      .btn-item-piece-collection {
        background-image: url(${bgPieceCollectionNewYear});
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position-x: center;
        background-position-y: center;
        box-shadow: -10px 10px 20px 0px #351212cc;
        gap: 0px;
        &:hover,
        &:active {
          background-image: url(${bgPieceCollectionNewYear});
        }
        span {
          text-shadow: -1px -1px 0 #00386f, 1px -1px 0 #00386f,
            -1px 1px 0 #00386f, 1px 1px 0 #00386f;
        }
        @media (max-width: 768px) {
          img {
            width: 36px;
          }
        }
      }
    }
    .btn-item {
      width: 256px;
      height: 72px;
      border-radius: 9999px;
      color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 8px;
      span {
        font-weight: 700;
        font-size: 20px;
      }

      &:hover,
      &:active {
        background-color: transparent;
        color: white;
      }

      @media (max-width: 512px) {
        span {
          font-size: 16px;
        }
      }
      @media (max-width: 425px) {
        span {
          font-size: 14px;
        }
      }
    }

    .btn-item-take-prize {
      background-image: url(${bgTakePrize});
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position-x: center;
      background-position-y: center;
      background-color: transparent;
      border: none;

      span {
        text-shadow: -1px -1px 0 #c76216, 1px -1px 0 #c76216, -1px 1px 0 #c76216,
          1px 1px 0 #c76216;
      }
      &:hover,
      &:active {
        background-image: url(${bgTakePrize});
      }
    }

    .btn-item-piece-collection {
      background-image: url(${bgPieceCollection});
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position-x: center;
      background-position-y: center;
      background-color: transparent;
      border: none;
      span {
        text-shadow: -1px -1px 0 #003cd1, 1px -1px 0 #003cd1, -1px 1px 0 #003cd1,
          1px 1px 0 #003cd1;
      }
      &:hover,
      &:active {
        background-image: url(${bgPieceCollection});
      }
    }
  }

  @media (max-width: 768px) {
    .btn-group .btn-item-piece-collection span,
    .btn-group .btn-item-take-prize span {
      font-size: 14px;
    }

    .btn-group .btn-item-piece-collection img,
    .btn-group .btn-item-take-prize img {
      width: 24px;
    }
  }

  @media (max-width: 460px) {
    .btn-group .btn-item-piece-collection,
    .btn-group .btn-item-take-prize {
      display: block;
    }

    .btn-group .btn-item-piece-collection span,
    .btn-group .btn-item-take-prize span {
      display: block;
    }

    .btn-group .btn-item-piece-collection img,
    .btn-group .btn-item-take-prize img {
      position: relative;
      top: 8px;
      margin-top: -8px;
    }
  }

  @media (max-width: 390px) {
    .btn-group .btn-item-piece-collection span,
    .btn-group .btn-item-take-prize span {
      font-size: 12px;
    }
  }
`;

const Div = styled.div`
  height: 200px;
  width: 177px;
  flex-shrink: 0;
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;

  .icon-super-piece {
    position: absolute;
    bottom: 55%;
    transform: translateY(-50%);
    right: 10%;
    width: 24px;
    height: 24px;
    z-index: 3;

    @media (min-width: 426px) {
      transform: translateY(-50%);
      right: 8%;
      width: 36px;
      height: 36px;
    }
  }

  &.new-year-25-theme {
    .img-prize-tray {
      width: 80%;
    }

    .img-prize-tray-fw {
      max-width: 90%;
    }
  }

  .img-prize-tray {
    width: 90%;
    height: auto;
  }

  .forward {
    width: 90%;
    position: absolute;
    bottom: 0;
    z-index: 2;

    .forward-inner {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      .prize-name {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 2;
        text-align: center;
        color: #fff;
        font-weight: 700;
        font-size: 15px;
        text-shadow: -1px -1px 0 #c76216, 1px -1px 0 #c76216, -1px 1px 0 #c76216,
          1px 1px 0 #c76216;
      }
    }
  }

  .prize {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }

  @media (max-width: 425px) {
    width: 150px;
    height: 170px;

    .forward {
      .forward-inner {
        .prize-name {
          font-size: 14px;
        }
      }
    }

    .prize {
      max-width: 70%;
      height: auto;
    }
  }
`;
